// pages/InactiveUsers.jsx
import React from 'react';
import UserListBase from './UserListBase';

const InactiveUsers = () => (
    <UserListBase statusFilter="inactive" title="Inactive Users" subtitle="Users/devices currently deactivated" />
);

export default InactiveUsers;